/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungStandortErfuellungDto } from '../../models/lexplus-anforderung-standort-erfuellung-dto';
import { LexplusUpdateAllAnforderungErfuellungsgradDto } from '../../models/lexplus-update-all-anforderung-erfuellungsgrad-dto';

export interface AnforderungDetailControllerUpdateAnforderungErfuellungsgradForAllStandorteV1$Params {
  anforderungsversionID: number;
      body: LexplusUpdateAllAnforderungErfuellungsgradDto
}

export function anforderungDetailControllerUpdateAnforderungErfuellungsgradForAllStandorteV1(http: HttpClient, rootUrl: string, params: AnforderungDetailControllerUpdateAnforderungErfuellungsgradForAllStandorteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LexplusAnforderungStandortErfuellungDto>>> {
  const rb = new RequestBuilder(rootUrl, anforderungDetailControllerUpdateAnforderungErfuellungsgradForAllStandorteV1.PATH, 'patch');
  if (params) {
    rb.path('anforderungsversionID', params.anforderungsversionID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LexplusAnforderungStandortErfuellungDto>>;
    })
  );
}

anforderungDetailControllerUpdateAnforderungErfuellungsgradForAllStandorteV1.PATH = '/v1/compliance/anforderungen/{anforderungsversionID}/erfuellungsgrad';
